import request from './index'

/** 工单列表 */
export function fetchTicketList(params = {}) {
  return request.get('/ticket/list.php', { params })
}

/** 工单详情 */
export function fetchTicketDetail(id) {
  return request.get('/ticket/detail.php', { params: { id } })
}

/** 创建工单 */
export function createTicket(payload) {
  return request.post('/ticket/create.php', payload)
}

/** 回复工单 */
export function replyTicket(payload) {
  return request.post('/ticket/reply.php', payload)
}

/** 结束工单 */
export function closeTicket(id) {
  return request.post('/ticket/close.php', { id })
}

/** 上传工单图片（转 WebP） */
export function uploadTicketImage(file) {
  const form = new FormData()
  form.append('file', file)
  return request.post('/ticket/upload.php', form, {
    timeout: 60000
  })
}
